import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { logError } from '@utils/errorLogging';
import { createError } from '@utils/errorUtils';

import { UserViewModel } from './types';

export async function fetchUser(): Promise<UserViewModel> {
  try {
    const response: V4ApiResponse<UserViewModel> = await apiClient.get('/User');

    if (!response.isSuccess) {
      throw new Error(response.errors[0]?.message ?? 'Not logged in!');
    }

    return response.value;
  } catch (error: unknown) {
    logError('fetchUser', error as Error);
    throw createError(error, 'Failed to fetch user');
  }
}

export async function saveNotificationPreferences(preferences: {
  bellEnabled: boolean;
  toastEnabled: boolean;
  toastPosition: string;
}): Promise<void> {
  try {
    const response: V4ApiResponse<unknown> = await apiClient.post(
      '/User/notificationPreferences',
      preferences,
    );

    if (!response.isSuccess) {
      throw new Error(
        response.errors[0]?.message ??
          'Failed to save notification preferences',
      );
    }
  } catch (error: unknown) {
    logError('saveNotificationPreferences', error as Error);
    throw createError(error, 'Failed to save notification preferences');
  }
}
